import { render, staticRenderFns } from "./RegulatoryUpdateInvestmentProfile.vue?vue&type=template&id=598d484a&scoped=true"
import script from "./RegulatoryUpdateInvestmentProfile.vue?vue&type=script&lang=ts"
export * from "./RegulatoryUpdateInvestmentProfile.vue?vue&type=script&lang=ts"
import style0 from "./RegulatoryUpdateInvestmentProfile.vue?vue&type=style&index=0&id=598d484a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598d484a",
  null
  
)

export default component.exports